import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/tipo-de-documento';

/**
 * Get Tipos de Documentos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDeDocumentos = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Documento
 * @params {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDeDocumento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo De Documento
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeDocumento = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo De Documento
 * @param {number} id
 * @param {object} values
 * @returns {promise<object|booolean>}
 */
export const patchTipoDeDocumento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo De Documento
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteTipoDeDocumento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
